(function($) {
    $(document).ready(function() {
        $('.hero-block_title-rotating-text').each(function () {
            const $container = $(this);
            const $items = $container.find('.hero-block_title-rotating-text-item');
            
            if ($items.length <= 1) {
                $items.show();
                $container.css('width', $items.eq(0).outerWidth() + 20 + 'px');
                return;
            }

            const maxWidth = Math.max(...$items.map(function () {
                return $(this).outerWidth();
            }).get());
            
            $container.css('width', maxWidth + 20 + 'px');

            let forward = true;
            let index = 0;
            let interval;

            function rotateText() {
                $items.removeClass('slide-down slide-up').hide();
                const $currentItem = $items.eq(index);
                $currentItem.show().addClass(forward ? 'slide-down' : 'slide-up');

                if (forward) {
                    index++;
                    if (index >= $items.length) {
                        forward = false;
                        index--;
                    }
                } else {
                    index--;
                    if (index < 0) {
                        forward = true;
                        index++;
                    }
                }
            }

            rotateText();
            interval = setInterval(rotateText, 3000);

            $container.hover(
                function () {
                    clearInterval(interval);
                },
                function () {
                    interval = setInterval(rotateText, 3000);
                }
            );
        });
    });
})(jQuery);